import tagTester from './_tagTester.js';

export default tagTester('Number');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isNumber.js
// module id = 128
// module chunks = 0 1